const SESSION_CLAIM = 'https://centerbase.com/sessionid'
const SITE_CLAIM = 'https://centerbase.com/cbsite'
const USER_ID_CLAIM = 'https://centerbase.com/cbuserid'
const IS_ADMIN_CLAIM = 'https://centerbase.com/isadmin'

let getAccessTokenFn = null

export const setAccessTokenGetter = (getter) => {
  getAccessTokenFn = getter
}

const decodeToken = (token) => {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null
    const payload = parts[1]
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded)
  } catch {
    return null
  }
}

export const getTokenClaims = async () => {
  if (!getAccessTokenFn) {
    throw new Error('Auth0 token getter not initialized')
  }

  const token = await getAccessTokenFn()
  if (!token) throw new Error('No access token available')

  const claims = decodeToken(token)
  if (!claims) throw new Error('Failed to decode token')

  return claims
}

export const getSessionId = async () => {
  const claims = await getTokenClaims()
  const sessionId = claims[SESSION_CLAIM]
  if (!sessionId) {
    throw new Error('No Centerbase session ID in token.')
  }
  return sessionId
}

export const getSiteFromToken = async () => {
  const claims = await getTokenClaims()
  return claims[SITE_CLAIM] || null
}

export const getCBUserId = async () => {
  const claims = await getTokenClaims()
  return claims[USER_ID_CLAIM] || null
}

export const isAdmin = async () => {
  const claims = await getTokenClaims()
  const val = claims[IS_ADMIN_CLAIM]
  return val === true || val === 'true' || val === 1
}

export const getUserDisplayName = async () => {
  const claims = await getTokenClaims()
  return claims.name || claims.nickname || claims.email || 'User'
}

export const clearSession = () => {
  // No cached state to clear in this simplified version
}
